// let cursorFeatureActive = false;

// $(document).ready(() => {
//   $("body").on(
//     "click",
//     ".search-drawer-button.flex.items-center.justify-center",
//     function () {
//       // console.log("Executed 2");

//       let search_field = $(".search__field .input");
//       if (search_field) {
//         setTimeout(() => {
//           search_field.click();
//         }, 600);
//       }
//     }
//   );
// });
// const colorCode = {
//   "Cherry Red": "#91272c",
//   Raspberry: "#651d32",
//   vanilla: "#cda788",
// };
// function checkWizzyConfigAndUpdate() {
//   window.wizzyConfig &&
//     (window.matchMedia("(max-width: 768px)").matches
//       ? (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
//           dom: '.search-drawer [name="q"]',
//           type: "search",
//         })
//       : (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
//           dom: '.search-drawer [name="q"]',
//           type: "search",
//         }),
//     clearInterval(interval));
// }

// // dom: '.search-drawer [name="q"]';
// // type: "search";

// // "#MainContent"

// // ".main-content"
// var interval = setInterval(checkWizzyConfigAndUpdate, 100);

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: '.search-drawer [name="q"]',
        type: "search",
      };
      window.wizzyConfig.common.isOnCategoryPage == !0
        ? (data.common.lazyDOMConfig.contentDOMIdentifiers = [
            "#wizzy-shopify-collection-page-wrapper",
          ])
        : (data.common.lazyDOMConfig.contentDOMIdentifiers = [
            "#MainContent",
            ".main-content",
          ]);
      // data.common.lazyDOMConfig.contentDOMIdentifiers = [
      //   "#MainContent",
      //   ".main-content",
      // ];
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      const sortCloseDiv = document.querySelector(
        ".wizzy-common-select-container .wizzy-common-select-options.sort-close"
      );
      if (sortCloseDiv) {
        sortCloseDiv.style.display = "none";
      }
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      products.forEach((product) => {
        if (product.swatches && product.swatches.length) {
          product.swatches[0]?.values?.forEach((swatchData) => {
            swatchData.isSwatch = true;
            swatchData.isURLSwatch = false;
            swatchData.isVisualSwatch = true;
            swatchData.swatch = {
              type: "visual",
              value: swatchData.value ? swatchData.value : "#fff",
            };
            //console.log("swatchData : ", swatchData);
            swatchData.swatchValue = colorCode[swatchData.value];
            // ? window.wizzyCustomColors[swatchData.value]
            // : "#fff";
          });
        }
        product.images = product.images.slice(0, 3);
        if (product.images.length > 0) {
          product.images.unshift(product.mainImage);
        }
        product.sellingPrice = product.sellingPrice.split(".")[0];
        product.price && (product.price = product.price.split(".")[0]);
        if (product.attributes) {
          product.attributes.forEach((atr) => {
            if (atr.id === "product_avg_rating_loox") {
              product.avg_rating = atr.values[0].value[0];
            } else if (atr.id === "product_product_card_offer_custom") {
              product.product_card_offer = atr.values[0].value[0];
            } else if (atr.id === "product_product_card_offer_show_custom") {
              if (atr.values[0].value[0] === "Bestseller") {
                product.isBestSeller = true;
              }
              product.product_card_offer_show_custom = atr.values[0].value[0];
            }
          });
        }
        product.frontUrl = product.url.split("?variant=")[0];
      });
      // console.log("Products data : ", products);
      return products;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // payload.swatch = [{ key: "colors" }];
      const SearchDrawer = document.querySelector("#SearchDrawer");
      const body = document.querySelector("body");

      if (
        SearchDrawer &&
        body &&
        body.classList.contains("has-modal-open") &&
        SearchDrawer.hasAttribute("active")
      ) {
        SearchDrawer.removeAttribute("active");
        SearchDrawer.removeAttribute("open");
        SearchDrawer.setAttribute("hidden", "");
        body.classList.remove("has-modal-open");
      }

      const headerSection = document.querySelector(
        ".shopify-section-group-header-group.header-section"
      );
      if (
        headerSection &&
        headerSection.classList.contains("header-transparent")
      ) {
        headerSection.classList.remove("header-transparent");
      }
      const autoCompletewrapper = document.querySelector(
        ".wizzy-body-end-wrapper .wizzy-autocomplete-wrapper.onLeft"
      );
      // console.log("autocomplete : ", autoCompletewrapper);
      if (autoCompletewrapper) {
        autoCompletewrapper.style.display = "none";
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      $(
        ".product-card__title, .recommendation-class .product-card__title"
      ).each(function () {
        const fullTitle = $(this).text().trim();
        const maxLength = 30;
        if (fullTitle.length > maxLength) {
          $(this).text(fullTitle.slice(0, maxLength) + "...");
        }
      });
      $(
        ".autocomplete-top-products .wz-product-card .horizontal-product__title"
      ).each(function () {
        const fullTitle = $(this).text().trim();
        const maxLength = 30;
        if (fullTitle.length > maxLength) {
          $(this).text(fullTitle.slice(0, maxLength) + "...");
        }
      });
      // sort code starts here
      let sortClose = document.querySelector(
        ".wizzy-common-select-options.sort-close"
      );
      if (sortClose) {
        sortClose.addEventListener("click", function () {
          if (window.innerWidth > 768) {
            document
              .querySelectorAll(
                ".wizzy-common-select-options.sort-close, .wizzy-common-select-options.sort-close-border"
              )
              .forEach((el) => {
                el.style.display = "none";
              });
          }
        });
      }
      // sort code ends here
      // cross cursor code start here

      document
        .querySelector(
          ".wizzy-search-filters-drawer-button .button.button--secondary.icon-with-text.wizzy-filters-desktop-entry"
        )
        .addEventListener("click", () => {
          cursorFeatureActive = !cursorFeatureActive;
        });

      document
        .querySelectorAll(
          ".wizzy-search-filters-left-wrapper, .wizzy-filters-header, .wizzy-filters-close-btn"
        )
        .forEach((el) => {
          el.addEventListener("mouseenter", () => {
            if (cursorFeatureActive) {
              document
                .querySelector(".mouse-cursor")
                .classList.remove("active");
              document.body.style.cursor = "default";
            }
          });

          el.addEventListener("mouseleave", () => {
            if (cursorFeatureActive) {
              document.querySelector(".mouse-cursor").classList.add("active");
              document.body.style.cursor = "none";
            }
          });
        });

      document.addEventListener("mouseout", (event) => {
        if (cursorFeatureActive && !event.relatedTarget) {
          document.querySelector(".mouse-cursor").classList.remove("active");
        }
      });

      document.addEventListener("mouseover", (event) => {
        if (cursorFeatureActive && !event.relatedTarget) {
          document.querySelector(".mouse-cursor").classList.add("active");
        }
      });

      document
        .querySelectorAll(".wizzy-filters-bg, .wizzy-filters-close-btn")
        .forEach((el) => {
          el.addEventListener("click", () => {
            cursorFeatureActive = false;
            document.querySelector(".mouse-cursor").classList.remove("active");
            document.body.style.cursor = "default";
          });
        });
      // cross cursor code end here

      document
        .querySelector(
          ".search-filters-top-wrapper .wizzy-common-select-wrapper .wizzy-common-select-selector"
        )
        .addEventListener("click", function (params) {
          const filterBG = document.querySelector(
            ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-filters-bg"
          );
          if (filterBG) {
            filterBG.style.display = "none";
          }
        });

      var sourceElement = document.querySelector(".wizzy-search-sort-wrapper");

      if (sourceElement) {
        var clonedContent = sourceElement.cloneNode(true);

        var targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");
        if (window.innerWidth < 768) {
          if (
            targetDiv &&
            !targetDiv.querySelector(".wizzy-search-sort-wrapper")
          ) {
            targetDiv.appendChild(clonedContent);
          }
        } else {
          if (targetDiv) {
            var clonedSort = targetDiv.querySelector(
              ".wizzy-search-sort-wrapper"
            );
            if (clonedSort) {
              clonedSort.remove();
            }
          }
        }
      }

      if (window.innerWidth < 768) {
        const filterHeaderTitle = document.querySelector(
          ".wizzy-search-filters-left .wizzy-filters-header .header-title"
        );
        if (filterHeaderTitle) {
          // console.log("Condition executed");
          filterHeaderTitle.textContent = "Filter and sort";
        }
        var sortInFilter = document.querySelector(
          ".wizzy-search-filters-left-wrapper .wizzy-sort-wrapper-in-filter"
        );

        if (
          sortInFilter &&
          !sortInFilter.classList.contains("click-listener-attached")
        ) {
          sortInFilter.addEventListener("click", function (event) {
            // event.preventDefault();
            // event.stopPropagation();
            var sortOptions = document.querySelectorAll(
              ".wizzy-common-select-options"
            );
            if (sortOptions) {
              if (
                sortOptions[1].style.display === "none" ||
                sortOptions[1].style.display === ""
              ) {
                sortOptions[1].style.display = "grid";
                sortOptions[0].style.display = "none";
              } else {
                sortOptions[1].style.display = "none";
              }
            }
          });
          sortInFilter.classList.add("click-listener-attached");
        }
        var hoverElement = document.querySelector(
          ".wizzy-common-select-container > .wizzy-common-select-selector"
        );

        if (
          hoverElement &&
          !hoverElement.classList.contains("click-listener-attached")
        ) {
          hoverElement.addEventListener("click", function (event) {
            var sortOptions = document.querySelectorAll(
              ".wizzy-common-select-options"
            );

            if (sortOptions.length > 1) {
              if (
                sortOptions[1].style.display === "none" ||
                sortOptions[1].style.display === ""
              ) {
                sortOptions[1].style.display = "grid";
                sortOptions[0].style.display = "none";
              } else {
                sortOptions[1].style.display = "none";
              }
            }
          });

          hoverElement.classList.add("click-listener-attached");
        }
      }
      let mainElement = document.querySelector("main");

      if (mainElement) {
        // Create a new div element
        let newContent = document.createElement("div");
        newContent.innerHTML = `
            <div class="add-to-cart-popup hide">
                <div class="kart">
                    <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_iconCarrier">
                            <path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M11.5 23.5C17.8513 23.5 23 18.3513 23 12C23 9.65732 22.2995 7.47825 21.0965 5.66083L11.9536 15.8197C11.0686 16.803 9.57924 16.9483 8.52078 16.1544L4.34444 13.0222C3.77988 12.5988 3.66547 11.7979 4.08889 11.2333C4.51231 10.6688 5.31322 10.5543 5.87778 10.9778L10.0541 14.11L19.4401 3.68109C17.376 1.71027 14.5793 0.5 11.5 0.5C5.14873 0.5 0 5.64873 0 12C0 18.3513 5.14873 23.5 11.5 23.5Z" fill="#fff"></path>
                        </g>
                    </svg>
                </div>
                 Product added to cart!
          <a class="cart-popup-trigger" href="javascript.void(0);">View Cart</a>
            </div>
        `;

        // Append the new content inside <main> without removing existing content
        mainElement.appendChild(newContent);
      }
      // console.log("VIEW_RENDERED");
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      // console.log("PRODUCTS_CACHED_RESULTS_RENDERED");
      return payload;
    }
  );

  changeTemplate("wizzy-autocomplete-wrapper");
  changeTemplate("wizzy-autocomplete-topproducts");
  changeTemplate("wizzy-search-results-product");
  changeTemplate("wizzy-search-wrapper");
  changeTemplate("wizzy-common-select");
};

const changeTemplate = function (div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;
  oldDiv.text = newDiv;
};
